"use client";

import { Accordion, Heading, RichText } from "@pamperedchef/design-system";

import type { DurableProductDetails as DurableProductDetailsBlockProps } from "@/types/references";

import styles from "./styles.module.scss";

/**
 * Durable Product Details block component
 */
export function DurableProductDetailsBlock(
	props: DurableProductDetailsBlockProps
): JSX.Element {
	return (
		<div className={styles["durable-product-details"]}>
			<Heading tag={props.headline_tag} styledAs="h2">
				{props.accordion_items_title}
			</Heading>
			<Accordion
				sections={props.accordion_items.map((item) => ({
					title: item.title,
					content: (
						<RichText
							content={item.content}
							className={styles["rich-text"]}
						/>
					)
				}))}
			/>
		</div>
	);
}
